export default "__VITE_ASSET__CxVvVwZ0__"